import React from 'react';

const Pagination = ({ perPage, total, paginate,currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(total / perPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className='pagination'>
        {pageNumbers.map(number => (
          <li key={number} className='page-item'>
            <a onClick={() => paginate(number)} href='#' className='page-link'>
              {number==currentPage?<React.Fragment><b>{number}</b></React.Fragment>:<React.Fragment>{number}</React.Fragment>}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Pagination;
